import React from 'react';
import styled from 'styled-components';

import { Black } from '../../../../../cra/src/styling/theme';

import breakpointsMinWidth from '../../../../../cra/src/styling/breakpointsMinWidth';

const Wrap = styled.div`
  color: ${Black};
  display: flex;
  grid-column-gap: 1.5rem;
  text-align: center;
  flex-direction: column;
  align-items: center;

  @media ${breakpointsMinWidth.mobileMd} {
    grid-column: 1/5;
  }

  @media ${breakpointsMinWidth.tabletSm} {
    grid-column: 2/8;
  }

  @media ${breakpointsMinWidth.tabletMd} {
    grid-column: 3/11;
  }
`;

const HeadingsP = styled.p`
  align-items: center;
  text-align: center;
  font-size: 28px;
  line-height: 36px;
  font-weight: 400;
  color: #122241;
  margin: 0;

  @media ${breakpointsMinWidth.tabletSm} {
    font-size: 32px;
    line-height: 64px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 36px;
    line-height: 64px;
  }
`;

const SubheadingP = styled.p`
  text-align: center;
  font-size: 14px;
  line-height: 21px;
  font-weight: 400;
  padding-top: 6px;
  color: #122241;
  margin-top: 8px;

  @media ${breakpointsMinWidth.tabletSm} {
    margin-top: 8px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
    line-height: 23px;
    margin-top: 14px;
  }
`;

const Headings = ({ data }) => {
  const { heading1, subHeading1 } = data.Headings.children[0];
  return (
    <>
      <Wrap>
        {heading1 && <HeadingsP>{heading1}</HeadingsP>}
        {subHeading1 && <SubheadingP>{subHeading1}</SubheadingP>}
      </Wrap>
    </>
  );
};

export default Headings;
